export default __webpack_public_path__ + "assets/images/image1.66dd41.png";